var map = {
	"./sign-10.png": "b7f0",
	"./sign-20.png": "4a4a",
	"./sign-30.png": "a61f",
	"./sign-40.png": "9ba9",
	"./sign-50.png": "84bc",
	"./sign-60.png": "fe97",
	"./sign-70.png": "e573",
	"./sign-80.png": "adae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b8";